export const LIMIT_HOURS_REFRESH = 24;
